/**
 * Replace triggers
 * @param {String} input
 * @returns {String}
 */
const replaceTriggers = (input) => {
  let result = input;

  if (result.includes("::")) {
    result = result.replace(/^\w+::/g, (string) => {
      return string.replace("::", "▶");
    });
  }

  if (result.includes("):")) {
    result = result.replace(/^(.*?)\)(?=:)/, (string) => {
      if (string.includes("╳")) {
        string = string.replace(/\[(?:[^\[\]]*╳[^\[\]]*)\]/g, (item) =>
          item.replace("╳", "▏")
        );
      }

      return string.replace(/:/g, "˸");
    });
  }

  return result;
};

export default replaceTriggers;
